export default {"src":"/_next/static/media/stars_2.1d126de1.svg","height":756,"width":756,"blurWidth":0,"blurHeight":0};